import _extends from "@babel/runtime-corejs2/helpers/extends";
import * as React from 'react';
var HelpMessage = function HelpMessage(_ref) {
  var text = _ref.text;
  // eslint-disable-next-line no-underscore-dangle
  var content = text !== null && text !== void 0 && text.__html ? {
    dangerouslySetInnerHTML: text
  } : {
    children: text
  };
  return /*#__PURE__*/React.createElement("p", _extends({
    className: "form-help"
  }, content));
};
export default HelpMessage;